import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/work-in-progress.jpg'


const _hoisted_1 = { class: "mt-l" }
const _hoisted_2 = { class: "container-sm wip" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Work In Progress",
  class: "wip__img"
}, null, -1)
const _hoisted_4 = { class: "wip__text-block" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "wip__title" }, "Этой страницы не существует", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "wip__desc" }, "Возможно, была допущена опечатка.", -1)
const _hoisted_7 = { class: "btn btn-m btn-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_router_link, {
          to: "/",
          class: "mt-s"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_7, [
              _createTextVNode(" Вернуться на главную ")
            ])), [
              [_directive_ripple]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}